<label mat-dialog-title class="uk-text-title">{{ data.title }}</label>
<mat-dialog-content class="locations-picking">
  <table mat-table [dataSource]="data.missings" class="mat-elevation-z8">
    <ng-container matColumnDef="created_AT">
      <th mat-header-cell *matHeaderCellDef> Fecha primer envío</th>
      <td mat-cell *matCellDef="let element"> {{element.created_AT | date: "dd-MM-yyyy HH:mm:ss"}} </td>
    </ng-container>
    <ng-container matColumnDef="updated_AT">
      <th mat-header-cell *matHeaderCellDef> Fecha último envío</th>
      <td mat-cell *matCellDef="let element"> {{element.updated_AT | date: "dd-MM-yyyy HH:mm:ss"}} </td>
    </ng-container>
    <ng-container matColumnDef="entity_NAME">
      <th mat-header-cell *matHeaderCellDef> Origen </th>
      <td mat-cell *matCellDef="let element"> {{element.entity_NAME}} </td>
    </ng-container>
    <ng-container matColumnDef="api_NAME">
      <th mat-header-cell *matHeaderCellDef> API destino </th>
      <td mat-cell *matCellDef="let element"> {{element.api_NAME}} </td>
    </ng-container>
    <ng-container matColumnDef="confirmation_TYPE">
      <th mat-header-cell *matHeaderCellDef> Tipo de Confirmación </th>
      <td mat-cell *matCellDef="let element"> {{element.confirmation_TYPE}} </td>
    </ng-container>
    <ng-container matColumnDef="status">
      <th mat-header-cell *matHeaderCellDef> Estado </th>
      <td mat-cell *matCellDef="let element"> {{element.status}} </td>
    </ng-container>
    <ng-container matColumnDef="raw_ERROR">
      <th mat-header-cell *matHeaderCellDef> Código de Error </th>
      <td mat-cell *matCellDef="let element"> {{element.raw_ERROR}} </td>
    </ng-container>
    <ng-container matColumnDef="raw_DATA">
      <th mat-header-cell *matHeaderCellDef> Mensaje </th>
    <td mat-cell *matCellDef="let element">
      <button class="button-success" mat-raised-button focusable="false" (click)="viewMessaje(element.entity_NAME, element.raw_DATA)">
        Ver
      </button>
    </td>
    </ng-container>
    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
  </table>
  
  
</mat-dialog-content>
<mat-dialog-actions align="center">
  <button
    id="exit"
    mat-flat-button
    class="button-primary-event border-box button-success"
    class="m-2"
    [mat-dialog-close]="'ok'"
  >
    Salir
  </button>
</mat-dialog-actions>
<button id="closeAddAddress" mat-button mat-dialog-close class="dialog-close">
  <mat-icon>close</mat-icon>
</button>